<template>
  <span class="container-circle" :style="styles" />
</template>

<script>
export default {
	props: {
		styles: {
			type: Object,
			default: () => ({
				backgroundColor: '#7159c1',
				width: '50px',
				height: '50px',
				display: 'flex',
				borderRadius: '50%'
			})
		}
	}
};
</script>

<style>

</style>
